import { useMutation } from "@apollo/client/react";
import { DELETE_TEMPLATE } from "../../mutations/invoiceInterpretationTemplates/deleteTemplate";
import GET_CLIENT_TEMPLATES from "../../queries/documentHandler/getClientTemplates";

export const useDeleteTemplate = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [deleteTemplate, { data, loading, error }] = useMutation(
    DELETE_TEMPLATE,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_CLIENT_TEMPLATES],
      awaitRefetchQueries: true,
    },
  );

  return { deleteTemplate, data, loading, error };
};
